<template>
  <div class="financial-statement-item">
    <col-table :data="data" :pageSize="pageSize" :class="{ 'col-table--same': isSame, 'table-var': true }">
      <col-table-column label="日期" prop="endDate" :css="{ height: '50px' }">
        <template #header>
          <div class="date-header">
            <span>报告期<i class="iconfont icon-wenhao ml-4px" @click="popupVisible = true"></i></span>
            <span class="tongbi">
              {{ $t('同比')
              }}<span class="checkbox-wrap"><input type="checkbox" v-model="isSame" class="checkbox" /></span>
            </span>
          </div>
        </template>
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ scope.row.sortYear + scope.row.reportType }}</span>
            <span class="scale">{{ $t('同比') }}</span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="reportKind" label="报表种类">
        <template slot-scope="scope">{{
          $digitjs(reportKindMap[scope.row[formatAParams('reportKind')]]).isNull()
        }}</template>
      </col-table-column>
      <col-table-column prop="coverMonths" label="覆盖时期(月)">
        <template slot-scope="scope">{{ $digitjs(scope.row[formatAParams('coverMonths')]).isNull() }}</template>
      </col-table-column>
      <col-table-column prop="currency" label="报表货币">
        <template slot-scope="scope">{{ $digitjs(scope.row[formatAParams('currency')]).isNull() }}</template>
      </col-table-column>
      <col-table-column prop="grossWrittenPremium" label="毛承保费及保单费收入">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('grossWrittenPremium')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('grossWrittenPremiumYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('grossWrittenPremiumYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="premiumCededToReinsurers" label="分出保费">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('premiumCededToReinsurers')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('premiumCededToReinsurersYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('premiumCededToReinsurersYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="netWrittenPremium" label="净承保费及保单费收入">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('netWrittenPremium')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('netWrittenPremiumYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('netWrittenPremiumYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="unearnedPremiumReserves" label="未到期责任准备金变动">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('unearnedPremiumReserves')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('unearnedPremiumReservesYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('unearnedPremiumReservesYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="netEarnedPremium" label="已赚取保费及保费单收入净额" :css="mainDataStyle">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('netEarnedPremium')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('netEarnedPremiumYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('netEarnedPremiumYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="netInvestmentIncome" label="净投资收益">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('netInvestmentIncome')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('netInvestmentIncomeYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('netInvestmentIncomeYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="premiumAndInvestmentIncome" label="净保费及投资收益总额">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('premiumAndInvestmentIncome')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('premiumAndInvestmentIncomeYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('premiumAndInvestmentIncomeYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="gainsOnInvestments" label="已实现及未实现的投资收益/(亏损)">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('gainsOnInvestments')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('gainsOnInvestmentsYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('gainsOnInvestmentsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="netForeignExchangeGains" label="汇兑收益/(亏损)">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('netForeignExchangeGains')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('netForeignExchangeGainsYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('netForeignExchangeGainsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="otherOperatingIncome" label="其他营业收益">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('otherOperatingIncome')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('otherOperatingIncomeYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('otherOperatingIncomeYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="operatingIncome" label="营业收益总额" :css="mainDataStyle">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('operatingIncome')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('operatingIncomeYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('operatingIncomeYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="netCommissionExpenses" label="佣金支出净额">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('netCommissionExpenses')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('netCommissionExpensesYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('netCommissionExpensesYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="generalAndAdminExpenses" label="行政及其他费用">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('generalAndAdminExpenses')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('generalAndAdminExpensesYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('generalAndAdminExpensesYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="otherOperatingExpenses" label="其他营业支出">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('otherOperatingExpenses')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('otherOperatingExpensesYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('otherOperatingExpensesYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="totalBenefitsClaimsAndExpenses" label="保险业务支出及其他费用">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{
              $digitjs(scope.row[formatAParams('totalBenefitsClaimsAndExpenses')]).convert()
            }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('totalBenefitsClaimsAndExpensesYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('totalBenefitsClaimsAndExpensesYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="operatingProfit" label="营业利润" :css="mainDataStyle">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('operatingProfit')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('operatingProfitYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('operatingProfitYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="grossProfitMargin" label="营业毛利率" :css="mainDataStyle">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('grossProfitMargin')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('grossProfitMarginYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('grossProfitMarginYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="otherNonOperatingItems" label="其他非经营项目">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('otherNonOperatingItems')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('otherNonOperatingItemsYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('otherNonOperatingItemsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="joinContrEntitiesAssociates" label="共同控制公司及联营公司">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('joinContrEntitiesAssociates')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('joinContrEntitiesAssociatesYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('joinContrEntitiesAssociatesYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="profitBeforeTaxation" label="除税前溢利" :css="mainDataStyle">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('profitBeforeTaxation')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('profitBeforeTaxationYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('profitBeforeTaxationYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="taxation" label="税项">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('taxation')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('taxationYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('taxationYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="profitThePeriod" label="本期间溢利" :css="mainDataStyle">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('profitThePeriod')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('profitThePeriodYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('profitThePeriodYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="ownersOfTheCom" label="本公司股本持有人应占">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('ownersOfTheCom')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('ownersOfTheComYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('ownersOfTheComYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="nonControllingInterests" label="非控股权益">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('nonControllingInterests')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('nonControllingInterestsYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('nonControllingInterestsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="netProfit" label="净利润(纯利)" :css="mainDataStyle">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('netProfit')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('netProfitYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('netProfitYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="netIncomeRatio" label="净利率" :css="mainDataStyle">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('netIncomeRatio')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('netIncomeRatioYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('netIncomeRatioYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="returnOnEquity" label="净资产收益率(ROE)" :css="mainDataStyle">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('returnOnEquity')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('returnOnEquityYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('returnOnEquityYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="returnOnTotalAssets" label="资产收益率(ROA)" :css="mainDataStyle">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('returnOnTotalAssets')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('returnOnTotalAssetsYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('returnOnTotalAssetsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="otherComprehensiveIncome" label="其他全面收入">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('otherComprehensiveIncome')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('otherComprehensiveIncomeYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('otherComprehensiveIncomeYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="totalComprehensiveIncome" label="全面收入总额" :css="mainDataStyle">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('totalComprehensiveIncome')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('totalComprehensiveIncomeYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('totalComprehensiveIncomeYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="basicEPS" label="财报每股基本盈利">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('basicEPS')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('basicEPSYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('basicEPSYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="dilutedEPS" label="财报每股摊薄盈利">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('dilutedEPS')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('dilutedEPSYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('dilutedEPSYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="dps" label="财报每股派息">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('dps')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('dpsYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('dpsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="depreciation" label="物业、机器及设备折旧">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('depreciation')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('depreciationYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('depreciationYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="amortization" label="无形资产摊销">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('amortization')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('amortizationYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('amortizationYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="depreciationAmortization" label="折旧及摊销">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('depreciationAmortization')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('depreciationAmortizationYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('depreciationAmortizationYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="commonShareDividend" label="普通股股息">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('commonShareDividend')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('commonShareDividendYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('commonShareDividendYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="taxationRate" label="税率(%)">
        <template slot-scope="scope">{{ $digitjs(scope.row[formatAParams('taxationRate')]).convert() }}</template>
      </col-table-column>
    </col-table>
    <RkPopup :visible.sync="popupVisible"><ReportSheetPrompt /></RkPopup>
  </div>
</template>

<script>
import RkPopup from '@/components/common/Popup.vue'
import ReportSheetPrompt from '@/components/common/ReportSheetPrompt.vue'
export default {
  components: { RkPopup, ReportSheetPrompt },
  props: ['data', 'reportKindMap', 'mainDataStyle', 'formatAParams'],
  data() {
    return {
      isSame: false,
      popupVisible: false
    }
  },
  computed: {
    pageSize() {
      return this.isSame ? 1 : 2
    }
  }
}
</script>
